<template>
  <div>
    <CRow>
      <CCol sm="12">
        <CertificatesTable
          :items="certificates"
          hover
          striped
          border
          small
          fixed
          caption="Certificados"
          @refresh="refreshItems"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import CertificatesTable from '../../components/configuration/certificates/CertificatesTable.vue'
import ws from '../../services/certificates';
import store from '../../store'

export default {
  name: 'Certificates',
  components: { CertificatesTable },
  data: function () {
		return {
            certificates: []
        }
  },
  mounted: async function() {
    this.loading();
    let response = await ws.get(); 

    if(response.type == "success"){
      this.certificates = response.data;
    }
    this.loaded();
  },
  methods: {
    async refreshItems (items){
      this.loading();
      let response = await ws.get();

      if(response.type == "success"){
        this.certificates = response.data;
      }
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
